import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import Relationship from "@/pages/Relationship";
import RelationshipResults from "@/pages/RelationshipResults";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import { Toaster } from "@/components/ui/sonner";
import LanguageSelector from "@/components/LanguageSelector";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <LanguageSelector />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/results" element={<Results />} />
            <Route path="/relationship" element={<Relationship />} />
            <Route path="/relationship-results" element={<RelationshipResults />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
